// extracted by mini-css-extract-plugin
export default {"EditReport":"EditReport_EditReport__3cGqw","title":"EditReport_title__D0Gy8","otstup":"EditReport_otstup__UhAj6"};